export const tickets: Record<string, string> = {
  'Save as new': 'Mentés új elemként',
  Workflow: 'Munkafolyamat',
  'Organisation default': 'Szervezeti alapértelmezés',
  Unavailable: 'Nem elérhető',
  'Drafts & templates': 'Piszkozatok és sablonok',
  Drafts: 'Piszkozatok',
  Templates: 'Sablonok',
  Template: 'Sablon',
  'New draft': 'Új piszkozat',
  'New template': 'Új sablon',
  'Continue editing': 'Szerkesztés folytatása',
  'Edit template': 'Sablon szerkesztése',
  'Use template': 'Sablon használata',
  'Publish ticket': 'Hibajegy közzététele',
  'Save as template': 'Mentés sablonként',
  'Duplicate template': 'Sablon másolása',
  Archive: 'Archiválás',
  'Save template': 'Sablon mentése',
  'Draft or template name': 'Piszkozat vagy sablon neve',
  'Ticket name': 'Hibajegy neve',
  'Deadline offset (days)': 'Határidő eltolása (nap)',
  'Calculated from the date a template is used.': 'A sablon felhasználásának napjától számítva.',
  'Drafts become tickets. Templates remain available for reuse.':
    'A piszkozatokból hibajegyek készülnek. A sablonok újra felhasználhatók.',
  'Delete this draft or template?': 'Törli ezt a piszkozatot vagy sablont?',
  'Publish this draft as a ticket?': 'Közzéteszi ezt a piszkozatot hibajegyként?',
  'Saved items sync with your mobile app. Unsaved edits stay in this editor.':
    'A mentett elemek szinkronizálódnak a mobilalkalmazással. A nem mentett módosítások ebben a szerkesztőben maradnak.',
  'This item changed on another device.': 'Ezt az elemet egy másik eszközön módosították.',
  'Your unsaved changes are retained. Compare before choosing.':
    'A nem mentett módosításai megmaradtak. Választás előtt hasonlítsa össze az adatokat.',
  'Your changes': 'Az Ön módosításai',
  'Server changes': 'Szerveradatok',
  'This item was deleted or published. Save your changes as a new item.':
    'Ezt az elemet törölték vagy közzétették. Módosításait új elemként mentheti.',
  'Use server changes': 'Szerveradatok használata',
  'Keep my changes for review': 'Saját módosítások megtartása ellenőrzésre',
  'Discard unsaved changes?': 'Elveti a nem mentett módosításokat?',
  'Template saved.': 'A sablont mentettük.',
  Filters: 'Szűrők',
  'Clear filters': 'Szűrők törlése',
  Clear: 'Törlés',
  'No results': 'Nincs találat',
  'Workflow state': 'Munkafolyamat-állapot',
  'Status category': 'Állapotkategória',
  'Unassigned location': 'Nincs helyszín megadva',
  Overdue: 'Lejárt',
  'Due today': 'Ma esedékes',
  'Due within 7 days': '7 napon belül esedékes',
  'No deadline': 'Nincs határidő',
  'Custom range': 'Egyéni időszak',
  'Deadline from': 'Határidő ettől',
  'Deadline to': 'Határidő eddig',
  'Created from': 'Létrehozva ettől',
  'Created to': 'Létrehozva eddig',
  'Updated from': 'Módosítva ettől',
  'Updated to': 'Módosítva eddig',
  'Not submitted': 'Nem beküldött',
  'Awaiting verification': 'Ellenőrzésre vár',
  'Returned for correction': 'Javításra visszaküldve',
  Verified: 'Ellenőrzött',
  'Save draft': 'Piszkozat mentése',
  'Add comment': 'Hozzászólás',
  'Annotation data': 'Jelölési adatok',
  CRITICAL: 'Kritikus',
  Comments: 'Hozzászólások',
  Date: 'Dátum',
  English: 'Angol',
  'General contractor': 'Fővállalkozó',
  HIGH: 'Magas',
  IN_PROGRESS: 'Folyamatban',
  LOW: 'Alacsony',
  Magyar: 'Magyar',
  OPENED: 'Nyitott',
  'Other location': 'Egyéb helyszín',
  Phase: 'Munkafázis',
  Photos: 'Fotók',
  Priority: 'Prioritás',
  'Problem description': 'Hiba leírása',
  'Repair attempts': 'Javítási kísérletek',
  'Repair condition': 'Javítás feltétele',
  'Repair information': 'Javítás adatai',
  'Repair verified': 'Javítás ellenőrizve',
  'Repaired by': 'Javította',
  'Report language': 'Jelentés nyelve',
  Reporter: 'Bejelentő',
  'Reporter email': 'Bejelentő e-mail-címe',
  Responsible: 'Felelős',
  Review: 'Áttekintés',
  Search: 'Keresés',
  State: 'Állapot',
  Subcontractor: 'Alvállalkozó',
  'Synced tickets from ÉpKontroll mobile devices': 'Mobilalkalmazásból szinkronizált hibajegyek',
  'Ticket ID': 'Hibajegyazonosító',
  v: 'v',
  QUEUED: 'Várakozik',
  GENERATING: 'Készül',
  CANCELLING: 'Leállítás alatt',
  TIMED_OUT: 'Időtúllépés',
  EXPIRED: 'Lejárt',
  FAILED: 'Sikertelen',
  'Stop report': 'Jelentés leállítása',
  'Stop this report?': 'Leállítja a jelentéskészítést?',
  'Report history': 'Jelentési előzmények',
  'Worker unavailable': 'A jelentéskészítő nem érhető el.',
  'The report is still queued. Processing may be delayed.': 'A jelentés még várakozik. A feldolgozás késhet.',
  'Requested by': 'Kérte',
  Started: 'Elindult',
  Completed: 'Befejeződött',
  Download: 'Letöltés',
  Format: 'Formátum',
};
